import React from 'react'
import PropTypes from 'prop-types'
import OrderSubscription from './OrderSubscription'
import { BookshelfPlusLogo } from '../../core/icons'

function BookshelfSubscription(props) {
  const {
    order, bookshelfSubscription, trial, checkoutStep, userIsPlatinum, ...rest
  } = props


  const subText = () => {
    const price = userIsPlatinum ? '$6.99/mo.' : '$9.99/mo.'
    const openingText = trial ? 'After the free trial you will be billed' : 'You will be billed'

    return (
      <div>
        {openingText} {price} <span>Subscripton will be activated when you complete this order.</span>
      </div>
    )
  }

  const mainText = () => (
    <span><strong>Try it free for 30 days. </strong> Unlimited audiobooks & talks + over 2,000 eBooks. </span>
  )

  const checkText = () => {
    const text = trial ? 'Try it FREE for 30 days' : 'Sign Up for'
    const price = userIsPlatinum ? '$6.99/mo.' : '$9.99/mo.'

    return (
      <span>
        {text} {trial ? null : price}
      </span>
    )
  }

  return (
    <OrderSubscription
      logo={<BookshelfPlusLogo className="order-sub-image has-fill-plus" />}
      mainText={mainText()}
      checkText={checkText()}
      subText={subText()}
      subscription={bookshelfSubscription}
      order={order}
      checkoutStep={checkoutStep}
    />
  )
}

BookshelfSubscription.defaultProps = {
  order: {},
  bookshelfSubscription: {},
  trial: false,
  checkoutStep: '',
}

BookshelfSubscription.propTypes = {
  // The order that is being placed
  order: PropTypes.object,
  // The bookself plus mothly subscription plan
  bookshelfSubscription: PropTypes.object,
  // If the user has a trial or not
  trial: PropTypes.bool,
  // The step of checkout
  checkoutStep: PropTypes.string,
  // If the user is platinum or has added the platinum sub
  userIsPlatinum: PropTypes.bool,
}

export default BookshelfSubscription
